import { getApiUrl } from "utils/get-api-url";

let _csrfToken = null;

export async function fetchCsrfToken() {
  if (!_csrfToken) {
    try {
      await new Promise((resolve, reject) => {
        $.ajax({
          url: getApiUrl("csrf-token"),
          dataType: "json",
          success: data => {
            _csrfToken = data.csrfToken;
            resolve();
          },
          error: e => reject(e),
        });
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Failed to fetch CSRF token", e);
    }
  }
  return _csrfToken;
}

export function getCsrfToken() {
  return _csrfToken;
}
